import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router';
import { useTranslation } from 'react-i18next';

import { useTokenMutation } from '../network/mutations';
import { Loader } from '../components/common';

function SigninRedirect() {
  const [searchParams] = useSearchParams();
  const { i18n } = useTranslation();
  const { mutate, isPending, isSuccess } = useTokenMutation();
  const navigate = useNavigate();

  useEffect(() => {
    if (searchParams.has('error')) {
      throw new Error(searchParams.get('error'));
    }

    if (!isPending) {
      if (isSuccess) {
        navigate(`/${i18n.language}/home`);
      } else if (searchParams.has('code')) {
        mutate({ data: { code: searchParams.get('code') } });
      } else {
        navigate('/');
      }
    }
  }, [searchParams, isPending, isSuccess]);

  return <Loader />;
}

export default SigninRedirect;
